import { render, staticRenderFns } from "./TableCoreRecreating.vue?vue&type=template&id=36ca5cf3&"
import script from "./TableCoreRecreating.vue?vue&type=script&lang=js&"
export * from "./TableCoreRecreating.vue?vue&type=script&lang=js&"
import style0 from "./TableCoreRecreating.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VProgressCircular,VTooltip})
